import React from "react";
import { useRouteMatch } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Message, Modal } from "semantic-ui-react";

interface RouterParams {
  serviceCode: string;
}

interface ModalDeleteServiceProps {
  open: boolean;
  handleOpen: Function;
  handleDelete: Function;
}

const ModalDeleteService: React.FC<ModalDeleteServiceProps> = ({
  open,
  handleOpen,
  handleDelete,
}: ModalDeleteServiceProps) => {
  const { t } = useTranslation();
  const serviceCode = useRouteMatch<RouterParams>().params.serviceCode;

  const handleCancel = () => {
    handleOpen(false);
  };

  const handleConfirm = () => {
    handleDelete(serviceCode);
    handleOpen(false);
  };

  return (
    <Modal
      id={"modal-container"}
      className={""}
      size={"mini"}
      onClose={handleCancel}
      open={open}
    >
      <Modal.Header>{t("edit.service.delete.btn_title")}</Modal.Header>
      <Modal.Content className={"modal-content br0"}>
        <div className={"modal-text"}>
          <p>{t("edit.service.delete.message")}</p>
          <Message className={"modal-message"} color={"red"}>
            <p className={"text-center"}>{serviceCode}</p>
          </Message>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleCancel} style={{ backgroundColor: "#cfe1ff" }}>
          {t("btn.cancel")}
        </Button>
        <Button onClick={handleConfirm} positive>
          {t("btn.delete")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ModalDeleteService;
